import axios from "axios";
import config from "@config";

const API = `${config.api}/users`;

// Возвращает текущего пользователя
export const getDetails = () =>
  axios
    .get(`${API}/details`, { withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });


// Обновляет данные пользователя
export const updateSelf = (data) => axios
  .post(`${API}/update`, data, { withCredentials: true })
  .then((res) => res.data)
  .catch((err) => err.response.data || { error: true, message: err.message });
